import { RefObject } from 'react'

const scrollToRef = (
  ref: RefObject<HTMLElement>,
  options?: ScrollIntoViewOptions
) => {
  if (ref?.current) {
    ref.current.scrollIntoView({ behavior: 'smooth', ...options })
  }
}

export default scrollToRef
